import { createSlice } from '@reduxjs/toolkit';

export const MAX_COMPARISON_LISTINGS = 3;

const comparisonSlice = createSlice({
  name: 'comparison',
  initialState: { selectedIds: [] },
  reducers: {
    addListingToComparison: (state, action) => {
      const id = String(action.payload);
      if (!state.selectedIds.includes(id) && state.selectedIds.length < MAX_COMPARISON_LISTINGS) {
        state.selectedIds.push(id);
      }
    },
    removeListingFromComparison: (state, action) => {
      state.selectedIds = state.selectedIds.filter((id) => id !== String(action.payload));
    },
    clearComparison: (state) => {
      state.selectedIds = [];
    },
  },
});

export const {
  addListingToComparison,
  removeListingFromComparison,
  clearComparison,
} = comparisonSlice.actions;

export default comparisonSlice.reducer;